import React from 'react';
import { Container, Grid } from '@mui/material';
import { LinkedInIcon } from '../../assets/icons';
import TalenteesLogo from '../../image/Talentees-02.png';
import { useI18n } from '../../i18n';

export const Footer: React.FC = () => {
  const { t } = useI18n();
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: t.footer.company,
      links: [
        { label: t.footer.companyLinks.about, href: '/about' },
        { label: t.footer.companyLinks.careers, href: '/careers' },
      ],
    },
    {
      title: t.footer.support,
      links: [
        { label: t.footer.supportLinks.documentation, href: '#docs' },
        { label: 'hello@talentees.net', href: 'mailto:hello@talentees.net' },
      ],
    },
    {
      title: t.footer.legal,
      links: [
        { label: t.footer.legalLinks.privacy, href: '/legal/privacy' },
        { label: t.footer.legalLinks.terms, href: '/legal/terms' },
      ],
    },
  ];

  const socialLinks = [
    { icon: LinkedInIcon, href: 'https://www.linkedin.com/company/talenteescompany/', label: 'LinkedIn' },
  ];

  return (
    <footer className="border-t border-white/10 bg-black">
      <Container maxWidth="lg">
        <div className="py-16">
          <Grid container spacing={4}>
            {/* Brand Section */}
            <Grid item xs={12} md={4}>
              <div className="flex items-center gap-2 mb-4">
                <img src={TalenteesLogo} alt="Talentees" className="h-8" />
              </div>
              <p className="text-white/60 text-sm mb-6 max-w-xs">
                {t.footer.description}
              </p>
              <div className="flex items-center gap-3">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-lg bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors group"
                    aria-label={social.label}
                  >
                    <social.icon className="w-5 h-5 text-white/60 group-hover:text-white transition-colors" />
                  </a>
                ))}
              </div>
            </Grid>

            {/* Links Sections */}
            {footerSections.map((section) => (
              <Grid item xs={6} sm={3} md={2} key={section.title}>
                <h3 className="text-white font-semibold text-sm mb-4">{section.title}</h3>
                <ul className="space-y-3">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-white/60 hover:text-white text-sm transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </Grid>
            ))}
          </Grid>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/50 text-sm">
              © {currentYear} {t.footer.copyright}
            </p>
            <div className="flex items-center gap-6">
              <a href="/legal/privacy" className="text-white/50 hover:text-white text-sm transition-colors">
                {t.footer.legalLinks.privacy}
              </a>
              <a href="/legal/terms" className="text-white/50 hover:text-white text-sm transition-colors">
                {t.footer.legalLinks.terms}
              </a>
              <a href="/legal/cookies" className="text-white/50 hover:text-white text-sm transition-colors">
                {t.footer.legalLinks.cookies}
              </a>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};
